import React from 'react';
import {
    Box,
    Typography,
    Button,
    Link,
    Paper,
    Container
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ETLogo from '../../../../assets/environment-testing.png';
import { useNavigate } from 'react-router';

export const SuccessPage: React.FC = () => {
    const navigate = useNavigate();

    const handleReturnHome = () => {
        navigate('/instructions');
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: 'linear-gradient(180deg, #f0f4f8 0%, #e8eef3 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                py: 4
            }}
        >
            <Container maxWidth="md">
                <Paper
                    elevation={0}
                    sx={{
                        p: { xs: 3, md: 5 },
                        borderRadius: 3,
                        background: '#ffffff',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06), 0 8px 24px rgba(0, 0, 0, 0.08)',
                        border: '1px solid #e8e8e8',
                        position: 'relative',
                        textAlign: 'center',
                        overflow: 'hidden',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '5px',
                            background: 'linear-gradient(90deg, #003883 0%, #0056b3 100%)',
                        }
                    }}
                >
                    <Box
                        sx={{
                            mb: 6,
                            textAlign: 'center',
                            px: 2,
                        }}
                    >
                        <Link
                            href="https://www.eurofins.com.au/environment-testing/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                display: 'inline-block',
                                textDecoration: 'none',
                            }}
                        >
                            <Box
                                component="img"
                                src={ETLogo}
                                alt="Eurofins Environment Testing Logo"
                                onError={(e) => {
                                    e.currentTarget.style.display = 'none';
                                }}
                                sx={{
                                    width: {
                                        xs: 250,  // mobile
                                        sm: 350,  // tablet
                                        md: 450,  // desktop
                                    },
                                    maxWidth: '100%',
                                    height: 'auto',
                                    mb: 3,
                                }}
                            />
                        </Link>
                    </Box>
                    <CheckCircleIcon sx={{ fontSize: 50, color: 'success.main', mb: 4 }} />

                    <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'success.main', mb: 4 }}>
                        Your application has been submitted
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary', maxWidth: 700, fontSize: '14px', lineHeight: 1.6 }}>
                        Thank you for selecting Eurofins Environment Testing.
                    </Typography>

                    <Typography variant="body1" sx={{ color: 'text.secondary', mb: 6, maxWidth: 700, fontSize: '14px', lineHeight: 1.6 }}>
                        Our dedicated team will proceed to review the provided information and get back to you should there be any issues.
                    </Typography>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleReturnHome}
                    >
                        Return to instructions
                    </Button>
                </Paper>
            </Container>
        </Box>
    );
};

export default SuccessPage;